import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Carousel } from 'react-responsive-carousel';

import 'react-responsive-carousel/lib/styles/carousel.min.css';

const CLASS_PREFIX = 'product-image-modal';

const ThumbnailCarousel = ({ children, currentImage }) => {
  const totalThumbs = React.Children.count(children);
  const [currentIndex, setCurrentIndex] = React.useState(0);
  const visibleThumbs = 5;
  const maxIndex = Math.max(0, totalThumbs - visibleThumbs);

  const showPrev = currentIndex > 0;
  const showNext = currentIndex < maxIndex;

  const handlePrev = () => setCurrentIndex(prev => Math.max(0, prev - 1));
  const handleNext = () => setCurrentIndex(prev => Math.min(maxIndex, prev + 1));

  return [
    showPrev ? (
      <button
        key="prev"
        onClick={handlePrev}
        className="w-8 h-8 flex items-center justify-center text-gray-600 hover:text-gray-900"
        aria-label="Previous thumbnails"
      >
        <span className="icon">chevron_left</span>
      </button>
    ) : null,
    
    <div key="thumbs" className="flex-1 overflow-hidden">
      <div 
        className="flex transition-transform duration-200"
        style={{ 
          transform: `translateX(-${currentIndex * 100 / visibleThumbs}%)`,
          width: `${(totalThumbs / visibleThumbs) * 100}%`
        }}
      >
        {React.Children.map(children, (child, index) => (
          <div 
            key={index} 
            className={`flex-shrink-0 transition-opacity duration-200 ${
              currentImage === index ? 'opacity-100' : 'opacity-60 hover:opacity-80'
            }`}
            style={{ width: `${100 / visibleThumbs}%` }}
          >
            {child}
          </div>
        ))}
      </div>
    </div>,

    showNext ? (
      <button
        key="next"
        onClick={handleNext}
        className="w-8 h-8 flex items-center justify-center text-gray-600 hover:text-gray-900"
        aria-label="Next thumbnails"
      >
        <span className="icon">chevron_right</span>
      </button>
    ) : null
  ].filter(Boolean);

  // return (
  //   <div className="relative">
  //     <div className="flex items-center">
  //       {showPrev && (
  //         <button
  //           onClick={handlePrev}
  //           className="w-8 h-8 flex items-center justify-center text-gray-600 hover:text-gray-900"
  //           aria-label="Previous thumbnails"
  //         >
  //           <span className="icon">chevron_left</span>
  //         </button>
  //       )}
        
  //       <div className="flex-1 overflow-hidden">
  //         <div 
  //           className="flex transition-transform duration-200"
  //           style={{ 
  //             transform: `translateX(-${currentIndex * 100 / visibleThumbs}%)`,
  //             width: `${(totalThumbs / visibleThumbs) * 100}%`
  //           }}
  //         >
  //           {React.Children.map(children, (child, index) => (
  //             <div 
  //               key={index} 
  //               className={`flex-shrink-0 transition-opacity duration-200 ${
  //                 currentImage === index ? 'opacity-100' : 'opacity-60 hover:opacity-80'
  //               }`}
  //               style={{ width: `${100 / visibleThumbs}%` }}
  //             >
  //               {child}
  //             </div>
  //           ))}
  //         </div>
  //       </div>

  //       {showNext && (
  //         <button
  //           onClick={handleNext}
  //           className="w-8 h-8 flex items-center justify-center text-gray-600 hover:text-gray-900"
  //           aria-label="Next thumbnails"
  //         >
  //           <span className="icon">chevron_right</span>
  //         </button>
  //       )}
  //     </div>
  //   </div>
  // );
};

const LightboxZoomModal = (props) => {
  const { images, currentImage, onClose, onClickThumbnail } = props;

  const handleKeyPress = (event) => {
    if (event.keyCode === 27) {
      onClose();
    }
  };

  useEffect(() => {
    document.addEventListener('keydown', handleKeyPress);

    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!images || images.length === 0) return null;

  return (
    <div className={CLASS_PREFIX}>
      <div className={`${CLASS_PREFIX}__close`} onClick={onClose} />
      <div className={`${CLASS_PREFIX}__content`}>
        <Carousel
          onClickThumb={(index) => onClickThumbnail(index)}
          onChange={(index) => onClickThumbnail(index)}
          selectedItem={currentImage}
          showThumbs={true}
          showStatus={true}
          showIndicators={false}
          showArrows={true}
          // renderArrowNext={() => <span className="icon icon-outlined">chevron_right</span>}
          // renderArrowPrev={() => <span className="icon icon-outlined">chevron_left</span>}
          thumbWidth={100}
          renderArrowPrev={(onClickHandler, hasPrev, label) =>
            hasPrev && (
                <button type="button" onClick={onClickHandler} title={label} className="w-10 h-10 lg:w-14 lg:h-14 rounded-full border border-border-primary bg-white grid place-items-center absolute top-1/2 left-2 lg:left-8 translate-y-[-50%] cursor-pointer z-10">
                    <span className="icon icon-outlined" aria-hidden="true">chevron_left</span>
                </button>
            )
        }
        renderArrowNext={(onClickHandler, hasNext, label) =>
            hasNext && (
                <button type="button" onClick={onClickHandler} title={label} className="w-10 h-10 lg:w-14 lg:h-14 rounded-full border border-border-primary bg-white grid place-items-center absolute top-1/2 right-2 lg:right-8 translate-y-[-50%] cursor-pointer z-10">
                    <span className="icon icon-outlined" aria-hidden="true">chevron_right</span>
                </button>
            )
        }
        renderThumbs={(children) => 
          children.map((child, index) => (
            <div 
              key={index}
              // className={`transition-opacity duration-200 ${
              //   currentImage === index ? 'opacity-100' : 'opacity-60 hover:opacity-80'
              // }`}
            >
              {child}
            </div>
          ))
        }
        // renderThumbs={(thumbs) => (
        //     <div className="product-slider">
        //         {thumbs}
        //     </div>
        // )}
        >
          {images.map((image, index) => (
            <figure className={`${CLASS_PREFIX}__image`} key={index}>
              <img
                className={`${CLASS_PREFIX}__image--main`}
                itemProp="image"
                src={image.src}
                alt={image.alt}
              />
            </figure>
          ))}
        </Carousel>
      </div>
    </div>
  );
};

LightboxZoomModal.propTypes = {
  images: PropTypes.array,
  currentImage: PropTypes.number,
  onClickThumbnail: PropTypes.func,
  onClose: PropTypes.func,
};

const LightboxImages = (props) => {
  const { images, currentImage, onClickThumbnail, onClickMain, onClose, isOpen } =
    props;

  if (!images || images.length === 0) return null;

  return (
    <>
      <div className="row product-images">
        <div className="columns">
          <div className="product-slider">
            <Carousel
              onClickThumb={(index) => props.onClickThumbnail(index)}
              onChange={(index) => props.onClickThumbnail(index)}
              selectedItem={props.currentImage}
              showThumbs={true}
              showStatus={false}
              showIndicators={false}
              showArrows={!isOpen}
              thumbWidth={window.innerWidth < 1024 ? 50 : 100}
              width={'100%'}
              // infiniteLoop={true}
              centerMode={true}
              centerSlidePercentage={100}
              renderArrowPrev={(onClickHandler, hasPrev, label) =>
                hasPrev && (
                  <button type="button" onClick={onClickHandler} title={label} className="w-10 h-10 lg:w-14 lg:h-14 rounded-full border border-border-primary bg-white grid place-items-center absolute top-1/2 left-2 lg:left-8 translate-y-[-50%] cursor-pointer z-10">
                    <span className="icon icon-outlined" aria-hidden="true">chevron_left</span>
                  </button>
                )
            }
            renderArrowNext={(onClickHandler, hasNext, label) =>
                hasNext && (
                    <button type="button" onClick={onClickHandler} title={label} className="w-10 h-10 lg:w-14 lg:h-14 rounded-full border border-border-primary bg-white grid place-items-center absolute top-1/2 right-2 lg:right-8 translate-y-[-50%] cursor-pointer z-10">
                        <span className="icon icon-outlined" aria-hidden="true">chevron_right</span>
                    </button>
                )
            }
            renderThumbs={(children) => 
              // <div className="flex">
                children.map((child, index) => (
                  <div 
                    key={index}
                    // className={`shrink-0 size-[90px] ${
                    //   currentImage === index ? 'opacity-100' : 'opacity-60 hover:opacity-80'
                    // }`}
                  >
                    {child}
                  </div>
                )
              // </div>
            )}
            // renderThumbs={(children) => 
            //   children.map((child, index) => (
            //     <div 
            //       key={index}
            //       // className={`transition-opacity duration-200 ${
            //       //   currentImage === index ? 'opacity-100' : 'opacity-60 hover:opacity-80'
            //       // }`}
            //     >
            //       {child}
            //     </div>
            //   ))
            // }
            // renderThumbs={(thumbs) => thumbs}
            // renderThumbs={(thumbs) => (
            //   <ThumbnailCarousel currentImage={currentImage}>
            //     {thumbs}
            //   </ThumbnailCarousel>
            // )}
            >
              {images.map((image, index) => (
                <div key={index} className="relative">
                <figure
                  className={`product-image ${
                    currentImage == index ? 'active' : ''
                  }`}
                >
                  <img
                    className="product-detail__image--alter"
                    itemProp="image"
                    src={image.src}
                    alt={image.alt}
                  />
                  {/* <div
                    type="button"
                    disabled={currentImage !== index}
                    className="tiny button padding-1 product-image__zoom"
                    onClick={() => onClickMain(index)}
                  ></div> */}
                </figure>
                <button
                    type="button"
                    disabled={currentImage !== index}
                    className="size-10 hidden lg:grid place-items-center text-white absolute top-8 right-8 cursor-pointer z-10 bg-accent rounded-full [.thumb_&]:hidden"
                    onClick={() => onClickMain(index)}
                    aria-label="Zoom in"
                  >
                    <span className="icon icon-outlined" aria-hidden="true">zoom_in</span>
                  </button>
                </div>
              ))}
            </Carousel>
          </div>
        </div>
      </div>

      {isOpen ? (
        <LightboxZoomModal
          images={images}
          currentImage={currentImage}
          onClickThumbnail={onClickThumbnail}
          onClickMain={onClickMain}
          onClose={onClose}
        />
      ) : null}
    </>
  );
};

export default LightboxImages;

LightboxImages.propTypes = {
  images: PropTypes.array,
  currentImage: PropTypes.number,
  onClickThumbnail: PropTypes.func,
  onClickMain: PropTypes.func,
  onClose: PropTypes.func,
  isOpen: PropTypes.bool,
};
